module.exports = __webpack_public_path__ + "static/media/Other-Vatican.e18a9c16.jpg";